module.exports = {
  api: {
    baseUrl: `/deskbooking/api/v1`
  }
};
